import SkodaFormHeader from "./components/SkodaFormHeader";
import ServiceForm from "./components/ServiceForm";
import SkodaFooter from "./components/SkodaFooter";
import SkodaHeader from "./components/SkodaHeader";
import LoadingSpinner from "./components/LoadingSpinner";
import {useState} from "react";

function App() {
    const [loadingSpinnerOpen, setLoadingSpinnerOpen] = useState(false);

    return (<>
        <SkodaHeader/>

        <div className="container">

            <div className="triangle1"></div>
            <div className="triangle2"></div>

            <SkodaFormHeader/>
            <div className="wrapper">
                <ServiceForm setLoadingSpinnerOpen={setLoadingSpinnerOpen}/>
            </div>
        </div>

        <SkodaFooter/>

        <LoadingSpinner open={loadingSpinnerOpen}/>
    </>);
}

export default App;
